/* eslint-disable no-underscore-dangle */
import { Validator } from 'simple-vue-validator';

class Validate {
  email(email) {
    return Validator.value(email).email()._messages.length === 0;
  }
}

export default new Validate();
